import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = (seed) =>
  seed + (Math.floor(Math.random() * 90000000) + 10000).toString();

const triggerViaEmailPlaceholders = () => ({
  content: [
    {
      key: keyAuto('subject'),
      name: 'Email subject line',
      id: 'subject',
      selected: true,
      type: 'text',
      value: '',
    },
    {
      key: keyAuto('body'),
      name: 'Email body as plain text',
      id: 'body',
      selected: true,
      type: 'text',
      value: '',
    },
    {
      key: keyAuto('body_HTML'),
      name: 'Email body as HTML',
      id: 'html_body',
      selected: true,
      type: 'html',
      value: '',
    },
  ],
  addresses: [
    {
      key: keyAuto('sender'),
      name: 'Sender email addresses (from)',
      id: 'from',
      selected: true,
      type: 'text',
      value: '',
    },
    {
      key: keyAuto('recipient'),
      name: 'Recipient email addresses (To)',
      id: 'to',
      selected: true,
      type: 'text',
      value: '',
    },
    {
      key: keyAuto('Cc'),
      name: 'Recipient email addresses (Cc)',
      id: 'cc',
      selected: true,
      type: 'list',
      value: '',
    },
  ],
  metadata: [
    {
      key: keyAuto('headers'),
      name: 'Headers',
      id: 'headers',
      selected: true,
      type: 'text',
      value: '',
    },
  ],
});

const initData = () => ({
  outputPlaceholders: triggerViaEmailPlaceholders(),
  receiver: 'none',
});

const { getStore, defaultStore } = createComponentStore({
  type: 'trigger_via_email',
  endpoint: 'trigger_via_email',
  registryKey: 'trigger_via_email',
  initData,

  onLoadData: (rawData) => {
    const data = { ...rawData };
    // v1 → v2 field compat mapping
    if (data.incomingMessagePlaceholders != null && data.outputPlaceholders == null) {
      data.outputPlaceholders = data.incomingMessagePlaceholders;
      delete data.incomingMessagePlaceholders;
    }
    return data;
  },

  extraState: () => ({
    placeholders: [],
    position: null,
    focus: null,
  }),

  extraActions: (set, get) => ({
    keyAuto,
    triggerViaEmailPlaceholders,

    setOutputPlaceholders: (outputPlaceholders) =>
      set((s) => ({
        data: { ...s.data, outputPlaceholders },
      })),

    // Backward-compat alias
    setIncomingMessagePlaceholders: (incomingMessagePlaceholders) =>
      set((s) => ({
        data: { ...s.data, outputPlaceholders: incomingMessagePlaceholders },
      })),

    setReceiver: (receiver) =>
      set((s) => ({
        data: { ...s.data, receiver },
      })),

    // Backward-compat alias used by prefillComponentStores
    setEmailTrigger: (component) => {
      get().setComponentData(component);

      // When there is no componentData, the original store added receivingEmails: true
      if (!component.componentData) {
        set((s) => ({
          data: { ...s.data, receivingEmails: true },
        }));
      }
    },

    // Override getTemplate to include position and placeholders
    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        position: s.position,
        type: s.type,
        lastModified: s.lastModified,
        data: JSON.parse(JSON.stringify(s.data)),
        placeholders: [...s.placeholders],
      };
    },
  }),
});

export const getEmailTriggerStore = getStore;
export default defaultStore;
